import { defineStore } from "pinia";
import { useHighlightsField } from "./lib/useHighlightsField";

export const useCurationNonIncluded = defineStore("curation-content-non-included-field", () => {
  return useHighlightsField({
    id: "non_included",
    fieldKey: "non_included",
    masterDataStoreKey: "included",
    searchPlaceholderKey: "experience.premade.search.exclusions",
  });
});
